<template>
  <section class="d-flex flex-column align-items-center">
    <div class="header-background-wrapper">
      <div class="header-background-left"></div>
      <div class="header-background-right"></div>
    </div>
    <div class="main-content">
      <div class="heading-text">
        <h1 class="heading-title">{{ $t('home.newVexels.header.title') }}</h1>
        <h2 class="heading-subtitle">{{ $t('home.newVexels.header.subtitle') }}</h2>
      </div>
      <Video
        id="plans-video-container"
        :options="playerOptions"
        :classes="'video-player-box overflow-hidden rounded h-100 mt-5 mb-5'"
        :playsinline="true"
      />
      <div class="experiences-cta">
        <div class="merch-cta white-cta">
          <div>
            <div class="cta-title">{{ $t('home.newVexels.sector1.titleMerch') }}</div>
            <div class="cta-subtitle">
              {{ $t('home.newVexels.sector1.descriptionMerch') }}
            </div>
          </div>
          <nuxt-link
            :to="$urlBuilder('search', { path: 'merch-designs', keyword: '' })"
            class="merch-cta-button white-cta-button-merch"
          >
            {{ $t('home.newVexels.sector1.ctaMerch') }}
          </nuxt-link>
        </div>
        <div class="design-cta white-cta">
          <div>
            <div class="cta-title">{{ $t('home.newVexels.sector1.titleDesign') }}</div>
            <div class="cta-subtitle">
              {{ $t('home.newVexels.sector1.descriptionDesign') }}
            </div>
          </div>
          <nuxt-link
            :to="$urlBuilder('search', { path: 'design-graphics', keyword: '' })"
            class="design-cta-button white-cta-button-design"
          >
            {{ $t('home.newVexels.sector1.ctaDesign') }}
          </nuxt-link>
        </div>
      </div>
      <div class="grid-features">
        <div class="row-feature">
          <div class="row-feature-text-wrapper">
            <div class="row-feature-title">{{ $t('home.newVexels.sector2.title1') }}</div>
            <div class="row-feature-subtitle">
              <p>
                {{ $t('home.newVexels.sector2.description1') }}
              </p>
            </div>
          </div>
          <div class="row-feature-image">
            <img
              src="https://cdn.vexels.com/img/new-vexels/featured1.jpg"
              :alt="$t('home.newVexels.sector2.alt1')"
            />
          </div>
        </div>
        <div class="row-feature">
          <div class="row-feature-text-wrapper">
            <div class="row-feature-title">{{ $t('home.newVexels.sector2.title2') }}</div>
            <div class="row-feature-subtitle">
              <p>
                {{ $t('home.newVexels.sector2.description2') }}
              </p>
            </div>
          </div>
          <div class="row-feature-image">
            <img
              src="https://cdn.vexels.com/img/new-vexels/featured2.jpg"
              :alt="$t('home.newVexels.sector2.alt2')"
            />
          </div>
        </div>
        <div class="row-feature">
          <div class="row-feature-text-wrapper">
            <div class="row-feature-title">{{ $t('home.newVexels.sector2.title3') }}</div>
            <div class="row-feature-subtitle">
              <p>
                {{ $t('home.newVexels.sector2.description3') }}
              </p>
            </div>
          </div>
          <div class="row-feature-image">
            <img
              src="https://cdn.vexels.com/img/new-vexels/featured3.jpg"
              :alt="$t('home.newVexels.sector2.alt3')"
            />
          </div>
        </div>
        <div class="row-feature">
          <div class="row-feature-text-wrapper">
            <div class="row-feature-title">{{ $t('home.newVexels.sector2.title4') }}</div>
            <div class="row-feature-subtitle">
              <p>
                {{ $t('home.newVexels.sector2.description4') }}
              </p>
            </div>
          </div>
          <div class="row-feature-image">
            <img
              src="https://cdn.vexels.com/img/new-vexels/featured4.jpg"
              :alt="$t('home.newVexels.sector2.alt4')"
            />
          </div>
        </div>
      </div>
      <div class="brands-block">
        <div class="brands-block-title">{{ $t('home.newVexels.sector3.brandsBlock1') }}</div>
        <img
          :src="`https://cdn.vexels.com/img/new-vexels/brands-row-pods${
            isMobile ? '-mobile' : ''
          }.png`"
          :alt="$t('home.newVexels.sector3.PODsAlt')"
        />
      </div>
      <Faq :new-vexels="customFaq" />
      <!-- <Faq /> -->
      <div class="brands-block">
        <div class="brands-block-title">{{ $t('home.newVexels.sector3.brandsBlock2') }}</div>
        <img
          :src="`https://cdn.vexels.com/img/new-vexels/brands-row-trusted${
            isMobile ? '-mobile' : ''
          }.png`"
          :alt="$t('home.newVexels.sector3.trustedAlt')"
        />
      </div>
      <div class="brands-block">
        <div class="brands-block-title">{{ $t('home.newVexels.sector3.brandsBlock3') }}</div>
        <img
          :src="`https://cdn.vexels.com/img/new-vexels/brands-row-featured${
            isMobile ? '-mobile' : ''
          }.png`"
          :alt="$t('home.newVexels.sector3.featuredAlt')"
        />
      </div>
      <div class="experiences-cta">
        <div class="merch-cta">
          <div class="merch-cta-illustration" />
          <div class="cta-text-wrapper">
            <div>
              <div class="cta-title color-cta">
                {{ $t('home.newVexels.sector4.merchDescription') + ' ' }}
                <span>{{ $t('home.newVexels.sector4.merchDescriptionStrong') }}</span>
              </div>
            </div>
            <nuxt-link :to="$urlBuilder('merch-home')" class="merch-cta-button">
              {{ $t('home.newVexels.sector4.merchCta') }}
            </nuxt-link>
          </div>
        </div>
        <div class="design-cta">
          <div class="design-cta-illustration" />
          <div class="cta-text-wrapper">
            <div>
              <div class="cta-title color-cta">
                {{ $t('home.newVexels.sector4.designDescription') + ' ' }}
                <span>{{ $t('home.newVexels.sector4.designDescriptionStrong') }}</span>
              </div>
            </div>
            <nuxt-link :to="$urlBuilder('design-home')" class="design-cta-button">
              {{ $t('home.newVexels.sector4.designCta') }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Video from '../components/Common/Video.vue';
import Faq from '../components/Common/Faq/index.vue';

export default {
  name: 'NewVexels',
  components: {
    Video,
    Faq
  },
  nuxtI18n: {
    paths: {
      en: '/new-vexels',
      de: '/neue-vexels',
      es: '/nuevo-vexels',
      pt: '/novo-vexels'
    }
  },
  data() {
    return {
      playerOptions: {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'https://cdn.vexels.com/video/new-vexels.mp4'
          }
        ],
        poster: 'https://cdn.vexels.com/img/new-vexels.png'
      },
      customFaq: [
        {
          question: this.$t('home.newVexels.faqs.q1'),
          answer: this.$t('home.newVexels.faqs.a1'),
          isOpen: false
        },
        {
          question: this.$t('home.newVexels.faqs.q2'),
          answer: this.$t('home.newVexels.faqs.a2'),
          isOpen: false
        },
        {
          question: this.$t('home.newVexels.faqs.q3'),
          answer: this.$t('home.newVexels.faqs.a3'),
          isOpen: false
        },
        {
          question: this.$t('home.newVexels.faqs.q4'),
          answer: this.$t('home.newVexels.faqs.a4'),
          isOpen: false
        },
        {
          question: this.$t('home.newVexels.faqs.q5'),
          answer: this.$t('home.newVexels.faqs.a5'),
          isOpen: false
        }
      ],
      windowWidth: 992
    };
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 992;
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.header-background-wrapper {
  width: 100vw;
  height: 500px;
  background: linear-gradient(#fff, #eee);
  position: absolute;
  z-index: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @include xl2 {
    height: 400px;
  }
  @include xl {
    height: 300px;
  }
  @include lg {
    align-items: center;
    height: 200px;
  }
}
.header-background-left {
  background-image: url('https://cdn.vexels.com/img/new-vexels/header-bg-left.png');
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
  width: 50%;
  height: 80%;
  @include lg {
    display: none;
  }
}
.header-background-right {
  background-image: url('https://cdn.vexels.com/img/new-vexels/header-bg-right.png');
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
  width: 50%;
  height: 80%;
  @include lg {
    display: none;
  }
}
.main-content {
  position: relative;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  width: 1100px;
  @include xl2 {
    width: 900px;
    padding-top: 120px;
  }
  @include xl {
    width: 800px;
    padding-top: 80px;
  }
  @include lg {
    width: 100vw;
    padding: 20px 8vw 0px 8vw;
  }
}
.heading-text {
  margin-bottom: 100px;
  font-weight: 500;
  text-align: center;
  @include lg {
    margin-bottom: 0px;
  }
}
.heading-title {
  font-size: 54px;
  color: #4a87f1;
  @include xl2 {
    font-size: 42px;
  }
  @include xl {
    font-size: 36px;
  }
  @include lg {
    font-size: 24px;
  }
}
.heading-subtitle {
  font-size: 24px;
  color: #313131;
  @include xl2 {
    font-size: 20px;
  }
  @include xl {
    font-size: 16px;
  }
  @include lg {
    font-size: 12px;
  }
}
.experiences-cta {
  margin-top: 40px;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  min-height: 260px;
  color: white;
  @include lg {
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 40px;
  }
}
.merch-cta {
  position: relative;
  width: 48%;
  min-height: 100%;
  padding: 40px 20px 40px 240px;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  background: #f65b5b;
  background-image: url('https://cdn.vexels.com/img/new-vexels/merch-cta-bg.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: repeat;
  @include lg {
    width: 100%;
    padding: 20px;
  }
}
.merch-cta-illustration {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 320px;
  height: 100%;
  border-radius: 8px;
  background-image: url('https://cdn.vexels.com/img/new-vexels/merch-cta.png');
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
  box-shadow: -200px 0px 80px -80px #fb5f60aa inset;
  @include lg {
    display: none;
  }
}
.cta-text-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
}
.cta-title {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 12px;
}
.cta-title span {
  font-weight: 400;
}
.cta-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
}
.merch-cta-button {
  background-color: white;
  width: max-content;
  padding: 16px 32px;
  color: $defaultColor;
  border-radius: 100px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.design-cta-button {
  background-color: white;
  width: max-content;
  padding: 16px 32px;
  color: rgb(53, 200, 176);
  border-radius: 100px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.design-cta {
  position: relative;
  width: 48%;
  min-height: 100%;
  padding: 40px 20px 40px 240px;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  background: #94e9de;
  background-image: url('https://cdn.vexels.com/img/new-vexels/design-cta-bg.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: repeat;
  @include lg {
    width: 100%;
    padding: 20px;
  }
}
.design-cta-illustration {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 320px;
  height: 100%;
  border-radius: 8px;
  background-image: url('https://cdn.vexels.com/img/new-vexels/design-cta.png');
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
  box-shadow: -200px 0px 80px -80px #1fb8b4aa inset;
  @include lg {
    display: none;
  }
}
.white-cta {
  flex-direction: column;
  justify-content: space-around;
  background: none;
  padding: 20px 40px;
  color: black;
  min-height: 260px;
  @include lg {
    padding: 0px;
  }
}
.white-cta-button-design {
  color: white;
  padding: 12px 48px;
  background-color: rgb(53, 200, 176);
}
.white-cta-button-merch {
  color: white;
  padding: 12px 48px;
  background-color: $defaultColor;
}
.color-cta {
  font-weight: 400;
  font-size: 32px;
  height: fit-content;
  @include lg {
    font-size: 20px;
  }
}
.grid-features {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 100px;
  margin-bottom: 40px;
  @include xl2 {
    gap: 80px;
  }
  @include xl {
    gap: 60px;
  }
  @include lg {
    gap: 40px;
  }
}
.row-feature {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex-wrap: nowrap;
  @include lg {
    flex-direction: column;
  }
}
.row-feature:nth-child(2n) {
  flex-direction: row-reverse;
  @include lg {
    flex-direction: column;
  }
}
.row-feature-text-wrapper {
  width: 500px;
  height: 500px;
  display: flex;
  flex-direction: column;
  padding: 80px 80px 100px 80px;
  @include xl2 {
    width: 410px;
    height: 410px;
    padding: 60px 60px 80px 60px;
  }
  @include xl {
    width: 370px;
    height: 370px;
    padding: 40px 40px 60px 40px;
  }
  @include lg {
    width: 100%;
    height: fit-content;
    padding: 16px 0px;
  }
}
.row-feature-title {
  line-height: 37px;
  font-weight: 500;
  font-size: 25px;
  color: black;
  margin-bottom: 26px;
}
.row-feature-image {
  width: 500px;
  height: 500px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @include xl2 {
    width: 410px;
    height: 410px;
  }
  @include xl {
    width: 370px;
    height: 370px;
  }
  @include lg {
    width: 100%;
    height: 42vw;
  }
  img {
    width: 100%;
    height: auto;
    @include lg {
      width: auto;
      height: 100%;
    }
  }
}
.brands-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 60px 0px 100px 0px;
}
.brands-block-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
  margin-bottom: 46px;
}
.brands-block img {
  width: 80%;
  height: auto;
}
</style>
